import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Switch } from '@/src/renderer/components/ui/switch'
import { getAnalyticsConsent, setAnalyticsConsent } from '@/src/renderer/lib/analytics'
import { SettingsSection, SettingsRow } from '../../primitives'
import { TestDataSection } from './TestDataSection'

/**
 * "Daten & Privatsphäre" page under "Profil & Daten". Hosts the analytics
 * consent toggle — moved here from the Appearance page ("App & Bedienung") —
 * and, for the beta, „Testdaten“ (#269).
 * Consent state lives in the analytics module's persistent store; the local
 * `useState` only mirrors it for the switch's visual checked-state.
 */
export function DataPrivacyPage() {
  const { t } = useTranslation()
  const [enabled, setEnabled] = useState(() => getAnalyticsConsent())

  return (
    <div className="data-privacy-page">
      <SettingsSection title={t('settings.section.privacy')} variant="card">
        <SettingsRow
          label={t('preferences.privacy.analyticsTitle')}
          description={t('preferences.privacy.analyticsDescription')}
          htmlFor="data-privacy-analytics-toggle"
          control={
            <Switch
              id="data-privacy-analytics-toggle"
              checked={enabled}
              onCheckedChange={(checked) => {
                setEnabled(checked)
                setAnalyticsConsent(checked)
              }}
            />
          }
        />
      </SettingsSection>
      <TestDataSection />
    </div>
  )
}
